import { DemandeDevis } from '@/models/DemandeDevis';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';

export interface DemandeDevisState {
    demandesDevis: DemandeDevis[];

    tableHeader: TableHeader[];

    page: number;
    count: number;
    nbOfPages: number;
    scroll: number;

    sort?: {
        sortData: string;
        sortStatus: SortType;
    };
    filterSite: Array<number>;
    filterStatus: Array<string>;
    filterDemandeDevisId: string;
    filterMine: boolean;

    isLoading: boolean;
    error?: Error;
    success: boolean;

    attachment: any;
    attachmentType: string;
    isAttachmentLoading: boolean;

    isExportXlsLoading: boolean;
}

export const initialState: DemandeDevisState = {
    demandesDevis: [],

    tableHeader: [
        {
            label: 'devis.request.id',
            sortData: 'id',
            sortStatus: SortType.DESC,
            width: '20%',
        },
        {
            label: 'devis.request.object',
            sortData: 'objet',
            sortStatus: SortType.NONE,
            width: '50%',
        },
        {
            label: 'devis.request.devis.ids',
            sortData: 'devis',
            sortStatus: SortType.INACTIVE,
            width: '20%',
            regleCle: 'suiviDemandeDevis.devisLies',
        },
        {
            label: 'devis.request.date',
            sortData: 'dateEnvoi',
            sortStatus: SortType.NONE,
            width: '20%',
        },
        {
            label: 'devis.request.site',
            sortData: 'adresseProjet.description',
            sortStatus: SortType.NONE,
            width: '20%',
        },
        {
            label: 'devis.request.etat',
            sortData: 'devis.etatDevis',
            sortStatus: SortType.NONE,
            width: '10%',
            regleCle: 'suiviDemandeDevis.statuts',
        },
    ],

    page: 0,
    count: 0,
    nbOfPages: 0,
    scroll: 0,

    sort: {
        sortData: 'id',
        sortStatus: SortType.DESC,
    },

    filterSite: [],
    filterStatus: [],
    filterDemandeDevisId: '',
    filterMine: false,

    isLoading: false,
    success: false,

    attachment: '',
    attachmentType: '',
    isAttachmentLoading: false,

    isExportXlsLoading: false,
};

export const state: DemandeDevisState = {
    ...initialState,
};
